import TextField from '@atoms/TextField';
import { Accessor, Setter, type Component, type JSX } from 'solid-js';
import { useTranslationState } from '@i18n/TranslationProvider';
import Button from '@atoms/Button';

import personIcon from '@assets/icons/person_new.svg';
import arrowIcon from '@assets/icons/arrow.svg';

export interface CreateOrJoinSessionBoxProps {
    userName: Accessor<string>;
    setUserName: Setter<string>;
    onCreateSession: () => void | unknown;
}

const CreateOrJoinSessionBox: Component<CreateOrJoinSessionBoxProps> = (
    props,
) => {
    const t = useTranslationState().t;
    return (
        <>
            <form
                onSubmit={(e) => {
                    props.onCreateSession();
                    e.preventDefault();
                }}
            >
                <TextField
                    value={props.userName()}
                    onInput={(newValue) => props.setUserName(newValue)}
                    placeholderText={t('homepage.name.placeholder')}
                    icon={personIcon}
                    type="text"
                />
                <div class="h-6" />
                <Button
                    onClick={() => props.onCreateSession()}
                    title={t('homepage.createSessionButton')}
                    fullWidth={true}
                    icon={arrowIcon}
                    variant="primary"
                ></Button>
            </form>
        </>
    );
};

export default CreateOrJoinSessionBox;
